<template>
  <div :class="['owc-feature-box-item', 'wb-grid-col-mq1-12', { 'wb-grid-col-mq5-3': !isEditMode }]">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <div class="owc-feature-box-item__wrapper">
      <p v-if="subtitle" v-test-id.ignore="'subtitle'" class="owc-feature-box-item__subtitle wb-type-label">
        {{ subtitle }}
      </p>
      <div>
        <span class="owc-feature-box-item__value wb-type-heading-l" v-test-id.ignore="'value'">{{
          value
        }}</span>
        <span
          v-html="unit"
          v-test-id.ignore="'unit'"
          class="owc-feature-box-item__unit wb-type-heading-m"
        ></span>
      </div>
      <div
        v-html="description"
        v-test-id.ignore="'description'"
        class="owc-feature-box-item__description wb-type-hint owc-rte-stylings"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { TestId } from '@owc-utils/TestIdDirective';
import { FeatureItemComponent } from './FeatureBoxItem';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src/ValidationBoxWrapper.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as FeatureItemComponent).extend({
  name: 'owc-feature-box-item',
  directives: {
    TestId,
  },
  components: {
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
  computed: {
    subtitle() {
      return this.componentData?.subtitle;
    },
    value() {
      return this.componentData?.value;
    },
    unit() {
      return this.componentData?.unit;
    },
    description() {
      return this.componentData?.description;
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rtl-utils';
@import '@owc-styles/utils/rte';

.owc-feature-box-item {
  /*
  * TODO: This doesn't work with webcomponents and since the
  * slotted pseudo element only allows simple-elements
  * we have to wait until a store is implemented to figure which
  * feature-box item is the last child
  */
  &:not(:last-child) {
    margin-bottom: var(--wb-spacing-s);

    @include breakpoint-from(mq5) {
      margin-bottom: 0;
    }
  }
  &__wrapper {
    padding: var(--wb-spacing-xxs) var(--wb-spacing-xs) var(--wb-spacing-s);

    @include breakpoint-from(mq3) {
      padding-bottom: var(--wb-spacing-xs);
    }
  }
  &__subtitle {
    margin-bottom: var(--wb-spacing-3xs);
  }
  &__unit {
    display: contents;
    margin-left: var(--wb-spacing-xxs);

    & > p {
      display: inline;
    }
  }
  &__description {
    display: contents;
    margin-top: var(--wb-spacing-xxs);
  }
}
</style>
